export default class AttachmentForm {
  public filename: string
  public content_type: string
}
